import { useEffect, useState } from "react";
import { faqs } from "@/mocks/manga";
import SectionTitle from "./SectionTitle";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionTitle
          eyebrow="常见问题"
          title="关于追更，你想知道的都在这里"
          desc="更新提醒、追更日历、自动续读……看看其他读者最常问的问题与解答。"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="font-medium text-foreground-900">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${
                      open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="border-t border-background-200 pt-4 text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}